import http from './index'

export default {
  /*
   * 获取导航配置
   * */
  query (params) {
    return http.get('/front/config/loginInfo', params)
  },
  /*
   * 设置导航配置
   * */
  set (params) {
    return http.post('/front/config/loginInfo/save', params)
  },
  /*
   * 根据用户名获取验证码
   * */
  verifyCode (params) {
    return http.post('/cas/verifyCode', params)
  },
  /*
   * 用户登录接口
   * */
  submit (params) {
    return http.post('/cas/login/submit', params)
  },
  /*
   * 用户退出登录接口
   * */
  logout (params) {
    return http.post('/cas/logout', params)
  },
  /*
   * 获取License过期时间
   * */
  getLicenseInfo () {
    return http.get('/front/public/getLicenseInfo')
  },
  /*
   * 获取支持的语言列表
   * */
  getLanguage () {
    return http.get('/front/common/language')
  },
  /*
   * 获取License激活信息
   * */
  getActiveInfo () {
    return http.get('/front/public/getActiveInfo')
  },
  isLogin () {
    return http.get('/front/common/isLogin')
  },
  // 保存和获取登录前后url
  saveLoginUrls (params) {
    return http.post('/front/config/loginInfo/loginUrl/save', params)
  },
  getLoginUrls () {
    return http.get('/front/config/loginInfo/loginUrl')
  }
}
